import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TeamIntro = ({ title, subHeading, paragraph }) => {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"]
  });

  const words = paragraph.split(" ");

  return (
    <section id="introduction" ref={container} className="team-intro-reveal">
      <div className="sticky-reveal-container">
        <div className="container">
          <div className="reveal-header">
            <Kicker index="01" label="OUR MANIFESTO" />
            <h2 className="reveal-title">
              THE <span className="gold-text">HUMAN</span> ELEMENT
            </h2>
            <h3 className="reveal-subheading italic">
              Architecting the Future of <span className="gold-text">Digital Expression</span>
            </h3>
          </div>
          
          <div className="reveal-text-body">
            {words.map((word, i) => {
              const start = (i / words.length) * 0.75;
              const end = start + (1 / words.length) * 0.75;
              return (
                <Word key={i} progress={scrollYProgress} range={[start, end]}>
                  {word}
                </Word>
              );
            })}
          </div>
        </div>
        
        {/* Progress bar for the reveal */}
        <div className="reveal-progress-bar">
          <motion.div 
            className="h-full bg-[var(--accentColor)]"
            style={{ scaleX: scrollYProgress, transformOrigin: "0%" }}
          />
        </div>
      </div>
    </section>
  );
};

const Word = ({ children, progress, range }) => {
  const opacity = useTransform(progress, range, [0.1, 1]);
  return (
    <span className="relative inline-block mr-[0.3em] mb-[0.1em]">
      <span className="absolute top-0 left-0 opacity-[0.03] select-none pointer-events-none whitespace-nowrap">
        {children}
      </span>
      <motion.span style={{ opacity }} className="relative z-10 whitespace-nowrap">
        {children}
      </motion.span>
    </span>
  );
};

const Kicker = ({ index, label }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--accentColor)]">{index}</span>
    <span className="w-16 h-px bg-[var(--rule)]" />
    <span className="font-impact text-[11px] tracking-[0.4em] text-white/40 uppercase">{label}</span>
  </div>
);

export default TeamIntro;
